export default __webpack_public_path__ + "static/media/swap-right.5b76153f.svg";